import { Component, OnInit, ViewChild, Input, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { GestockService } from '../services/gestock.service';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-statstock',
  templateUrl: './statstock.component.html',
  styleUrls: ['./statstock.component.css']
})
export class StatstockComponent implements OnInit {


  @Input() selectedBoutique: any;

  displayedColumns: string[] = [
    'categorie', 'nomarticle', 'rotation', 'frequencesortie', 
    'valeurstock', 'stockdormant', 'tauxdisponibilite', 
    'periodefortedemande', 'periodefaibledemande', 
    'niveaustock', 'previsiondemande'
  ];

  dataSource : MatTableDataSource<any> ;
  categories: string[] = [];
  newCategory: string = '';
  samacaabiyoonwii: string = '';
  retourClientWS: any;
  valeurStockTotale: number = 0;
  nbStockDormant: number = 0;

  valeurTotaleStock : any ; 
  moyenneRotation : any ;
  totalDormants : any ;
  tauxDisponibiliteMoyen : any ;



  donnees : any ;

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;


  constructor(private configServer: GestockService) {}

  ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
  }


  ngAfterViewInit(): void {
    this.getAllStatStock();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Changes : ", changes) ;
    if (changes['selectedBoutique']) {
      console.log('Nouvelle valeur :', changes['selectedBoutique'].currentValue);
      this.selectedBoutique = changes['selectedBoutique'].currentValue ;
      if(changes['selectedBoutique'].firstChange==false){
        console.log("Here we are !") ;
        this.getAllStatStock();
      }
    }
  }

  getAllStatStock(): void {
    this.configServer.getStatStockBoutique(this.samacaabiyoonwii, this.selectedBoutique).then((retour) => {
      this.retourClientWS = retour;

      if (retour.statutreq === 1) {
        let data = retour.data;
        this.donnees = data ;
        this.dataSource = new MatTableDataSource(data) ;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.updateAggregats(data);
      } else {
        console.error('Échec récupération stats');
      }
    });
  }

  getAllCategories(): void {
    this.configServer.getAllCategories(this.samacaabiyoonwii).then((retour) => {
      if (retour.statutreq === 1) {
        this.categories = retour.data;
      }
    });
  }


  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd ;
  }



  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByCategory(): void {
    if (this.newCategory === '') {
      this.getAllStatStock();
      return;
    }

    const filtered = this.dataSource.data.filter((item: any) =>
      item.categorie.toLowerCase() === this.newCategory.toLowerCase()
    );
    this.dataSource.data = filtered;
    this.updateAggregats(filtered);
  }

  updateAggregats(data: any[]): void {

    let valeurTotaleStock = 0;
    let totalRotation = 0;
    let totalDormants = 0;
    let totalTauxDisponibilite = 0;

    const totalArticles = data.length;

    data.forEach(item => {
      valeurTotaleStock += +item.valeurstock;
      totalRotation += +item.rotation;
      totalDormants += +item.stockdormant;
      totalTauxDisponibilite += +item.tauxdisponibilite;
    });

    const moyenneRotation = totalArticles > 0 ? totalRotation / totalArticles : 0;
    const tauxDisponibiliteMoyen = totalArticles > 0 ? totalTauxDisponibilite / totalArticles : 0;

    this.valeurTotaleStock =  Number(valeurTotaleStock); 
    this.moyenneRotation = Number(moyenneRotation.toFixed(4)) ;
    this.totalDormants = totalDormants ;
    this.tauxDisponibiliteMoyen =  Number(tauxDisponibiliteMoyen.toFixed(2)) ;

    console.log(valeurTotaleStock, moyenneRotation, totalDormants, tauxDisponibiliteMoyen) ;
   
  }

  calculerAgrégatsStock(data: any[]){

  }

  exportToExcel(): void {
    // Ajoute ici l'exportation via XLSX ou autre lib
    console.log('Fonction d’export Excel appelée');
  }

}
